module.exports = __webpack_public_path__ + "img/csfrom.6d89e548.png";